module.exports = __webpack_public_path__ + "media/machino.6382dbf6.mp3";